<template lang="html">
  <div class="showlist">
    <div v-for="show in shows" :key="'show' + show.id">
      <h1>{{ show.id }} - {{ show.ssid }}</h1>
      <p>
        <router-link
          :to="{ name: 'detail', params: { id: show.id.toString() } }"
          tag="button"
        >
          detail
        </router-link>
        <router-link
          :to="{ name: 'import', params: { id: show.id.toString() } }"
          tag="button"
        >
          import
        </router-link>
        <router-link
          v-show="show.data.slideArray"
          :to="{ name: 'edit', params: { id: show.id.toString() } }"
          tag="button"
        >
          edit
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowList",
  computed: {
    shows() {
      return this.$store.state.shows;
    }
  },
  mounted() {
    this.$store.dispatch("loadShows");
  },
  activated() {
    this.$store.dispatch("loadShows");
  }
};
</script>

<style lang="scss" scoped>
.showlist {
  padding: 10px;
  margin: 10px;
}
</style>
